




import Vue from 'vue';
import BaseBtn from './base-button.vue';

export default Vue.extend({
  name: 'RoundBtn',
  components: {
    BaseBtn,
  },
  props: {
    outline: Boolean,
    active: Boolean,
    left: Boolean,
    noIcon: Boolean,
    saved: Boolean,
  },
});
